import React from 'react';
import PropTypes from 'prop-types';

const ParkingSpotInfoHeader = ({
  spotId,
  amenities,
  location,
  size = '',
  surface,
}) => {
  return (
    <div className="spot-head">
      <h5>
        <div className="icon-marker-pin pull-left" />&nbsp;
        {location} {spotId}
      </h5>
      <span className="text-capitalize">{surface}</span> { size.trim() ? `- ${size}` : ''}
      <br />
      {amenities}
    </div>
  );
};

ParkingSpotInfoHeader.propTypes = {
  spotId: PropTypes.string,
  location: PropTypes.string,
  size: PropTypes.string,
  surface: PropTypes.string
};

export default ParkingSpotInfoHeader;



// WEBPACK FOOTER //
// ./src/components/MapInfoBar/ParkingSpotInfoHeader/index.js